import {EventBase} from "shared/utilities/Events/EventManager";

export class UpdateStyleSettingsPanel extends EventBase {
    ReturnType: void;

    constructor() {
        super();
    }

    public static GetName() {
        return 'UpdateStyleSettingsPanel';
    }
}